import { render, staticRenderFns } from "./ChangePwd.vue?vue&type=template&id=60b34667"
import script from "./ChangePwd.vue?vue&type=script&lang=js"
export * from "./ChangePwd.vue?vue&type=script&lang=js"
import style0 from "./ChangePwd.vue?vue&type=style&index=0&id=60b34667&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports